<template>
    <div>
        <div class="lista-smge" v-if="!loading">
            <ul>
                <li>
                    <h3>Selecione um ou mais horarios</h3>
                </li>
                <li v-for="(item, i) in horarios" :key="i" @click="selecionaHorario(i)" :style="{ backgroundColor: ((item.selecionado) ? '#c2dae7' : '') }">
                    <div class="box-data custom">
                        <img v-if="!item.selecionado" src="@/assets/img/check-none.png">
                        <img v-if="item.selecionado" src="@/assets/img/check-ok.png">
                        <h3>{{ item.horario }}º horário</h3>                        
                    </div>
                    <i class="fas fa-angle-right"></i>
                </li>
            </ul>
            <el-row :gutter="10">
                <div class="u-text-right u-mt-20">
                    <el-button type="primary" @click="horariosSelecionado">PROXIMO</el-button>
                </div>
            </el-row>

        </div>
    </div>
</template>
<script>

export default {
    props: ['turmaSelected'],
    data: () => ({
        loading: true,
        horarios: {}
    }),
    mounted () {

        for(let i = 0; i < this.turmaSelected.qtd_horarios; i++){
            this.$set(this.horarios, i, { horario: (i + 1), selecionado: false });
        }

        this.loading = false;
    },
    methods:{
        selecionaHorario(i){

            this.horarios[i].selecionado = !this.horarios[i].selecionado;
        },
        horariosSelecionado(){

            let selecionados = [];
            for(let i in this.horarios){
                if(this.horarios[i].selecionado){
                    selecionados.push(this.horarios[i].horario)
                }
            }

            if(selecionados.length == 0){

                window.eventBus.$emit('alert', {msg: 'Selecione um horário.', type: 'warning'});
                return;
            }

            this.$router.push(`/admin/diario/frequencia?data=${this.$route.query.data}&turma=${this.$route.query.turma}&disciplina=${this.$route.query.disciplina}&horarios=${selecionados}`);
        }
    }
}
</script>
<style>
    .lista-smge {
        max-width: 100%;
        margin: 0 auto;
        z-index: 1;
    }
    .lista-smge ul {
        list-style: none;
        padding-left: 0px;
    }
    .lista-smge li:not(:first-child) {
        color: #404040;
        border-bottom: 1px solid #eaeaea;
        cursor: pointer;
        padding: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .lista-smge li:first-child {
        padding: 10px;
        border-top: 1px solid #eaeaea;
        background-color: #f1f1f1;
    }
    .lista-smge h3 {
        margin: 0;
        font-weight: 400;
        color: #2d2d2d;
        font-size: 16px;
        letter-spacing: -.5px;
    }
    .lista-smge .freq-sub-titulo{
        font-weight: 300;
        color: #818181;
    }

    .lista-smge .box-data {
        padding-left: 10px;
    }

    .lista-smge .box-data.custom {
        padding-left: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .lista-smge .box-data.custom img {
        margin-right: 10px;
    }
</style>
